module.exports = __webpack_public_path__ + "img/messageline.516d059d.svg";